import Swiper from './swiper';
import Plyr from './plyr';
import './image-object-fit';

/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */

// Document Ready Stuff
$(document).ready(function() {
  var scroll = $(window).scrollTop();
  var header = $('.stickyHeader');

  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 225) {
      header.addClass('stickyHeader--stuck');
    } else {
      header.removeClass('stickyHeader--stuck');
    }
  });
});

// YouTube embed player.
const players = Plyr.setup('#player');


// Mobile Menu
const toggleMenu = (event) => {
  event.preventDefault();
  $('.js-menu-toggle, .footer-nav').toggleClass('open');
  $('.stickyHeader').toggleClass('menu-open');
  $('body').toggleClass('fixed');
};

$('.js-menu-toggle').on('click', toggleMenu);

// Page transition business
document.addEventListener('DOMContentLoaded', function() {
  if (!window.AnimationEvent) { return; }
  var anchors = document.getElementsByTagName('a');

  for (var idx=0; idx<anchors.length; idx+=1) {
    if (anchors[idx].hostname !== window.location.hostname ||
      anchors[idx].pathname === window.location.pathname) {
      continue;
    }

    anchors[idx].addEventListener('click', function(event) {
      var fader = document.getElementById('fader'),
          anchor = event.currentTarget;

      var listener = function() {
          window.location = anchor.href;
          fader.removeEventListener('animationend', listener);
      };
      fader.addEventListener('animationend', listener);

      event.preventDefault();

      fader.classList.add('fade-in');
    });
  }
});

window.addEventListener('pageshow', function (event) {
  if (!event.persisted) {
    return;
  }
  var fader = document.getElementById('fader');
  fader.classList.remove('fade-in');
});

// Banner Scroll
$(".banner__more").click(function(event) {
  event.preventDefault();

  $('html,body').animate({
    scrollTop: $(".introduction").offset().top - 84
  }, 'slow');
});

// Swiper for Recent Work
if (document.querySelector('.recentWork__grid')) {
  var work = new Swiper ('.recentWork__grid', {
    effect: "fade",
    fadeEffect: { crossFade: true },
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'custom',
      renderCustom: function (Swiper, current, total) {
        return ('0' + current).slice(-2) + ' / ' + ('0' + total).slice(-2);
      }
    }
  });
};

// Add / Remove active states on gravity form fields
$('.gfield input').each(function() {

  $(this).on('focus', function() {
    $(this).parent().parent('.gfield').addClass('active');
  });

  $(this).on('blur', function() {
    if ($(this).val().length == 0) {
      $(this).parent().parent('.gfield').removeClass('active');
    }
  });

  if ($(this).val() != '') $(this).parent('.css').addClass('active');

});

$('.gfield textarea').each(function() {

  $(this).on('focus', function() {
    $(this).parent().parent('.gfield').addClass('active');
  });

  $(this).on('blur', function() {
    if ($(this).val().length == 0) {
      $(this).parent().parent('.gfield').removeClass('active');
    }
  });

  if ($(this).val() != '') $(this).parent('.css').addClass('active');
});

$(document).on('gform_post_render', function(){

  $('.gfield input').each(function() {

    $(this).on('focus', function() {
      $(this).parent().parent('.gfield').addClass('active');
    });

    $(this).on('blur', function() {
      if ($(this).val().length == 0) {
        $(this).parent().parent('.gfield').removeClass('active');
      }
    });

    if ($(this).val() != '') $(this).parent('.css').addClass('active');
  });

  $('.gfield textarea').each(function() {

    $(this).on('focus', function() {
      $(this).parent().parent('.gfield').addClass('active');
    });

    $(this).on('blur', function() {
      if ($(this).val().length == 0) {
        $(this).parent().parent('.gfield').removeClass('active');
      }
    });

    if ($(this).val() != '') $(this).parent('.css').addClass('active');
  });

});